<template>
	<modal-box @close="close" :header="$t(`buttons.actions.${params.action}_contact`)"  :subHeader="$t('headers.general.watch_profile')" class="watch-profile-contact-form">
		<spinner v-if="model.loading"/>
		<error-box v-else-if="model.error" :error="model.error"/>
		<form v-else @submit.prevent="validateAndSubmit">
			<input-select v-model="model.data.type" :options="options" name="contact_type" :placeholder="$t('labels.general.type')" rules="required"/>
			<input-text v-model="model.data.contact" name="contact_contact" :placeholder="$t('labels.general.contact')" rules="required"/>
			<error-box v-if="form.error" :error="form.error"/>
			<div class="form-group-actions">
				<button-submit-icon-text :loading="form.loading" icon="save">{{ $t('buttons.general.save') }}</button-submit-icon-text>
			</div>
		</form>
	</modal-box>
</template>

<script>
import ApiObject from '@/classes/api/ApiObject'
export default {
	props: [
		'user_uid',
		'watch_id',
		'params'
	],
	data () {
		return {
			model: new ApiObject(),
			form: {
				loading: false,
				error: ''
			},
			options: [
				{ value: 'phone', text: this.$t('labels.general.phone') },
				{ value: 'email', text: this.$t('labels.general.email') },
				{ value: 'address', text: this.$t('labels.general.address') }
			]
		}
	},
	methods: {
		validateAndSubmit () {
			this.$validator.validateAll()
				.then(result => {
					if (result) this.submit()
				})
		},
		submit () {
			switch (this.params.action) {
				case 'add':
					this.addContact()
					break
				case 'edit':
					this.editContact()
					break
				default:
					this.$log.warn('watch profile contact form', 'action not set')()
			}
		},
		close (reload = false) {
			this.$emit('close', { reload })
		},
		getContact () {
			this.model.loading = true
			this.$api.profile.contacts.get(this, this.user_uid, this.watch_id, this.params.id)
				.then(response => {
					this.$log.info('watch profile contact form', 'profile.contacts.get OK', response)()
					this.model.data = response.body
				}).catch(error => {
					this.$log.error('watch profile contact form', 'profile.contacts.get ERROR', error)()
					this.model.error = error
				}).finally(() => {
					this.model.loading = false
				})
		},
		addContact () {
			this.form.loading = true
			this.$api.profile.contacts.add(this, this.user_uid, this.watch_id, this.model.data)
				.then(response => {
					this.$log.info('watch profile contact form', 'profile.contacts.add OK', response)()
					this.close(true)
				}).catch(error => {
					this.$log.error('watch profile contact form', 'profile.contacts.add ERROR', error)()
					this.form.error = error
				}).finally(() => {
					this.form.loading = false
				})
		},
		editContact () {
			this.form.loading = true
			this.$api.profile.contacts.edit(this, this.user_uid, this.watch_id, this.model.data)
				.then(response => {
					this.$log.info('watch profile contact form', 'profile.contacts.edit OK', response)()
					this.close(true)
				}).catch(error => {
					this.$log.error('watch profile contact form', 'profile.contacts.edit ERROR', error)()
					this.form.error = error
				}).finally(() => {
					this.form.loading = false
				})
		}
	},
	created () {
		switch (this.params.action) {
			case 'add':
				this.model.data = {
					type: '',
					contact: ''
				}
				break
			case 'edit':
				this.getContact()
				break
			default:
				this.$log.warn('watch profile contact form', 'action not set')()
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/profile/ContactForm.vue